import Router from 'vue-router'

const Home = resolve => {
  require.ensure(['../components/Home'], () => {
    resolve(require('../components/Home'))
  })
}
const Login = resolve => {
  require.ensure(['../components/Login'], () => {
    resolve(require('../components/Login'))
  })
}
const Questions = resolve => {
  require.ensure(['../components/Questions'], () => {
    resolve(require('../components/Questions'))
  })
}
const Question = resolve => {
  require.ensure(['../components/Question'], () => {
    resolve(require('../components/Question'))
  })
}
const Products = resolve => {
  require.ensure(['../components/Products'], () => {
    resolve(require('../components/Products'))
  })
}
const Product = resolve => {
  require.ensure(['../components/Product'], () => {
    resolve(require('../components/Product'))
  })
}
const Catalogs = resolve => {
  require.ensure(['../components/Catalogs'], () => {
    resolve(require('../components/Catalogs'))
  })
}
const Catalog = resolve => {
  require.ensure(['../components/Catalog'], () => {
    resolve(require('../components/Catalog'))
  })
}
const Services = resolve => {
  require.ensure(['../components/Services'], () => {
    resolve(require('../components/Services'))
  })
}
const Service = resolve => {
  require.ensure(['../components/Service'], () => {
    resolve(require('../components/Service'))
  })
}
const Concerns = resolve => {
  require.ensure(['../components/Concerns'], () => {
    resolve(require('../components/Concerns'))
  })
}
const Concern = resolve => {
  require.ensure(['../components/Concern'], () => {
    resolve(require('../components/Concern'))
  })
}
const ErrorPage = resolve => {
  require.ensure(['../components/Error'], () => {
    resolve(require('../components/Error'))
  })
}
const User = resolve => {
  require.ensure(['../components/User'], () => {
    resolve(require('../components/User'))
  })
}
const routes = [{
  name: 'login',
  path: '/login',
  component: Login
},
{
  name: 'questions',
  path: '/questions',
  component: Questions
},
{
  name: 'newQuestion',
  path: '/question',
  component: Question
},
{
  name: 'question',
  path: '/question/:id',
  component: Question,
  props: true
},
{
  name: 'catalogs',
  path: '/catalogs',
  component: Catalogs
},
{
  name: 'newcatalog',
  path: '/catalog',
  component: Catalog
},
{
  name: 'catalog',
  path: '/catalog/:id',
  component: Catalog,
  props: true
},
{
  name: 'concerns',
  path: '/concerns',
  component: Concerns
},
{
  name: 'newConcern',
  path: '/concern',
  component: Concern
},
{
  name: 'concern',
  path: '/concern/:id',
  component: Concern,
  props: true
},
{
  name: 'products',
  path: '/products',
  component: Products
},
{
  name: 'newProduct',
  path: '/product',
  component: Product
},
{
  name: 'product',
  path: '/product/:id',
  component: Product,
  props: true
},
{
  name: 'services',
  path: '/Services',
  component: Services
},
{
  name: 'newservice',
  path: '/Service',
  component: Service
},
{
  name: 'Service',
  path: '/service/:id',
  component: Service,
  props: true
},
{
  name: 'User',
  path: '/user',
  component: User
},
{
  name: 'Error',
  path: '*',
  component: ErrorPage
},
{
  name: 'home',
  path: '/',
  component: Home
}

]

let router = new Router({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  var isLogged = localStorage.isLogged

  if (!isLogged) {
    if (to.path === '/login') { next() } else { next('/login') }
  } else {
    var permission = localStorage.permission
    if (to.path === '/login') { next('/') }
    if (permission > 1) { next() } else if (permission === 1) {
      if (localStorage.catalog) { to.path === '/catalog/' + localStorage.catalog ? next() : next('/catalog' / +localStorage.catalog) } else { to.path === '/catalog' ? next() : next('/catalog') }
    }
  }
})

export default router
